import React, { Component } from 'react';
import axios from 'axios';
import {Link} from 'react-router-dom';
import ProgramCarbon from '../Program/ProgramCarbon';
import { DebounceInput } from 'react-debounce-input';
import Select from 'react-select';
import ContentLoader from "react-content-loader";
import InfiniteScroll from "react-infinite-scroll-component";

const CardLoader = () => (
   <ContentLoader height={320}>
      <rect x="0" y="0" rx="6" ry="6" width="100%" height="220" />
      <rect x="0" y="230" rx="6" ry="6" width="300" height="12" />
      <rect x="0" y="250" rx="6" ry="6" width="300" height="16" />
      <rect x="0" y="275" rx="6" ry="6" width="50" height="12" />
   </ContentLoader>
);

const selectStyles = {
   container: (base, state) => ({
      ...base,
      opacity: state.isDisabled ? ".5" : "1",
      backgroundColor: "transparent",
      zIndex: "995"
   })
};

class Carbon extends Component {
   state = {
      status: true,
      statusLogin : false,
      statusUser : false,
      error: null,
      loading: true,
      programs: [],
      hasMore : true,
      sellers: [],
      provinces: [],
      program_pagination: {
         page: 1, // Default Page
         limit: 12 // Default Limit
      },
      pagination: [],
      search_form: {},
      inputSearch: "",
      selectedOptionProvince: null,
      selectedOptionSeller: null
   }

   get_program_list = (statusLogin, configHeader) => {
      var selectedProvince = 'All';
      var selectedSeller = 'All';
      console.log('selectedOptionProvince is ', this.state.selectedOptionProvince);
      console.log('selectedOptionSeller is ', this.state.selectedOptionSeller);
      if(this.state.selectedOptionProvince !== null){
         selectedProvince = this.state.selectedOptionProvince.regionName
      }
      if(this.state.selectedOptionSeller !== null){
         selectedSeller = this.state.selectedOptionSeller.id
      }
      axios.get(process.env.REACT_APP_API_HOST + '/program/list/carbon/false?province=' + selectedProvince + '&corporateId='  + selectedSeller + '&page=' + this.state.program_pagination.page + '&limit=8', configHeader)
      .then(res => {
         console.log('res data ', res.data)
         if (res.data.status === true) {
            setTimeout(() => {
               var programsNew = this.state.programs;
               res.data.programs.map((listprogram) => {
                  programsNew.push(listprogram);
               });
               if(this.state.program_pagination.page < res.data.pagination.pageCount + 1) {
                  this.setState({
                     programs: programsNew,
                     sellers : res.data.sellers, 
                     provinces: res.data.provinces,
                     hasMore : true,
                     program_pagination : {page: res.data.pagination.page + 1},
                     loading:false
                  });
               } else {
                  this.setState({
                     programs: programsNew,
                     sellers : res.data.sellers, 
                     provinces: res.data.provinces,
                     hasMore : false,
                     loading:false
                  });
               }
            }, 1000)
         } else {
            this.setState({ status: false, error: res.data.error, loading: false, hasMore : false })
         }
      })
   }

   
   componentDidMount() {
      const userData = localStorage.getItem("userData");
      let statusLogin;
      if(userData){
         statusLogin = true;
         this.setState({statusUser : true})
         var configHeader = {
            headers: {
               "Content-Type": 'application/json',
               "token": JSON.parse(localStorage.getItem("userData")).token
            }
         }
         this.get_program_list(statusLogin, configHeader);
      } else {
         statusLogin = false;
         this.setState({statusUser : false})
         var configHeader = {
            headers: {
               "Content-Type": 'application/json',
               "token": ''
            }
         }
         this.get_program_list(statusLogin, configHeader);
      }
      console.log('userData is ', userData);
      
   }
   
   handleSelectProvince = selectedOptionProvince => {
      this.setState({ selectedOptionProvince, loading:true, programs: [], program_pagination: {
         page: 1, limit:8 } }, () => this.get_program_list() );
      console.log(`Option selected:`, selectedOptionProvince);
   };

   handleSelectSeller = selectedOptionSeller => {
      this.setState({ selectedOptionSeller, loading:true, programs: [], program_pagination: {
         page: 1, limit:8 } }, () => this.get_program_list() );
      console.log(`Option selected:`, selectedOptionSeller);
   };

   render() {

      return (
         <div className="mpl-page cp-85">
            <div className="container">
               <div className="row">
                  <div className="col-12">
                     {!this.state.statusUser ? (
                        <div className="wrapper-banner">
                        <div className="row align-items-center">
                           <div className="col-12 col-md-8">
                              <h2 className="mt-0 mb-0">Siap melawan pemanasan global?</h2>
                           </div>
                           <div className="col-12 col-md-4">
                              <div className="float-right wrapper-button-center">
                                 <Link to="/login" className="btn btn-outline-green" style={{backgroundColor:'#fff !important', fontWeight:'bold'}}>
                                    Masuk
                                 </Link>
                                 &nbsp; &nbsp;
                                 <Link to="/register" className="btn btn-green" style={{backgroundColor:'#fff !important', fontWeight:'bold'}}>
                                    Register
                                 </Link>
                              </div>
                           </div>
                        </div>
                     </div>
                     ) : ''}
                     <div className="wrapper-filter">
                        <div className="row">
                           <div className="col-auto">
                              <div style={{width:'175px', zIndex: 20}}>
                                 <h4 className="mt-0 mb-2">Lokasi</h4>
                                 <Select
                                 styles={selectStyles}
                                 className='react-select-container'
                                 classNamePrefix='react-select'
                                 defaultValue={{ value: '', regionName: 'All'}}
                                 onChange={this.handleSelectProvince}
                                 getOptionLabel={option =>
                                    `${option.regionName}`
                                 }
                                 getOptionValue={option => `${option.id}`}
                                 options={this.state.provinces}
                                 isSearchable={true}
                                 isClearable={true}
                                 />
                              </div>
                           </div>
                           <div className="col-auto">
                              <div style={{width:'175px', zIndex: 20}}>
                                 <h4 className="mt-0 mb-2">Penjual</h4>
                                 <Select
                                 styles={selectStyles}
                                 className='react-select-container'
                                 classNamePrefix='react-select'
                                 defaultValue={{ value: '', name: 'All'}}
                                 onChange={this.handleSelectSeller}
                                 getOptionLabel={option =>
                                    `${option.name}`
                                 }
                                 getOptionValue={option => `${option.id}`}
                                 options={this.state.sellers}
                                 isSearchable={true}
                                 isClearable={true}
                                 />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            {
               this.state.loading === true ? (
                  <div className="container">
                     <div className="row">
                        <div className="col-sm-6 col-md-4 col-lg-3">
                        <CardLoader/>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                        <CardLoader/>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                        <CardLoader/>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                        <CardLoader/>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                        <CardLoader/>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                        <CardLoader/>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                        <CardLoader/>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                        <CardLoader/>
                        </div>
                     </div>
                  </div>
               ) : (
                  <React.Fragment>
                     {
                        this.state.programs.length === 0 ? (
                           <div className="container">
                              <div className="row">
                                 <div className="col-sm-12">
                                    <div className="text-center" style={{height: '100px'}}>
                                       <small>Program not found</small>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        ) : (
                           <React.Fragment>
                              <InfiniteScroll
                                 dataLength={this.state.programs.length}
                                 next={this.get_program_list}
                                 hasMore={this.state.hasMore}
                                 loader={<div className="text-center" style={{marginTop:'40px',}}><div className="loader" style={{height:'24px', width:'24px', borderColor:'#00880d', borderTopColor:'#ddd', margin:'auto'}}></div></div>}>  
                                 <div className="container">
                                    <div className="row">
                                    {
                                       this.state.programs.map((program) => {
                                          return (
                                             <ProgramCarbon
                                                key={program.id}
                                                id={program.id}
                                                title={program.title}
                                                unit={program.unit}
                                                value={program.value}
                                                urlFeaturedImage={program.urlFeaturedImage}
                                                corporateName={program.corporateName}
                                                province={program.province}
                                                city={program.city}
                                                currencySymbol={program.currencySymbol}
                                                pricePerYear={program.pricePerYear}
                                                verified={program.verified} />
                                          )
                                       })
                                    }
                                    </div>
                                 </div>    
                              </InfiniteScroll>
                           </React.Fragment>
                        )
                     }
                  </React.Fragment>
               )
            }
         </div>
      )
   }
}

export default Carbon;